import { render, staticRenderFns } from "./bulletinEdit.vue?vue&type=template&id=4f5c2fdb&scoped=true"
import script from "./bulletinEdit.vue?vue&type=script&lang=js"
export * from "./bulletinEdit.vue?vue&type=script&lang=js"
import style0 from "./bulletinEdit.vue?vue&type=style&index=0&id=4f5c2fdb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5c2fdb",
  null
  
)

export default component.exports